{
  "en": {
    "baseSelect": {
      "homepageSetting": {
        "featuredModels": {
          "label": "Featured ships",
          "nullablePrompt": "No featured ships"
        }
      },
      "actions": {
        "fetchMore": "Load more"
      },
      "labels": {
        "search": "Type to search",
        "nullablePrompt": "No Option selected",
        "prompt": "Please select an Option",
        "removeTooltip": "Click to remove Option",
        "selectedCount": {
          "one": "%{count} selected",
          "other": "%{count} selected"
        }
      },
      "model": {
        "baseModel": {
          "label": "Base Model"
        }
      },
      "modelLoaner": {
        "loanerModel": {
          "label": "Loaner Model"
        }
      },
      "modelSnubCraft": {
        "snubCraft": {
          "label": "Snub Craft",
          "prompt": "Select a Snub Craft"
        }
      },
      "modelPosition": {
        "positionType": {
          "label": "Position Type",
          "prompt": "Select Position Type"
        },
        "source": {
          "label": "Source",
          "prompt": "Select Source"
        }
      },
      "fleet": {
        "members": {
          "shipsFilter": {
            "label": "Ships Filter",
            "prompt": "Select which ships to show",
            "nullablePrompt": "Select an option"
          },
          "blueprintsFilter": {
            "label": "Blueprints Filter",
            "prompt": "Select which blueprints to share",
            "nullablePrompt": "Select an option"
          },
          "hangarGroupId": {
            "label": "Hangar Group",
            "prompt": "Select a hangar group",
            "nullablePrompt": "Select a group"
          }
        }
      }
    }
  }
}
